import {
  ClientActivityBetweenSessionsCardConnected,
  ProviderEventType,
} from "@grow-therapy-team/seedling-components";
import {
  inSessionPatientInformationAtom,
  isInSessionWithSelectedClientAtom,
  providerShortIdAtom,
  selectedClientInfoAtom,
  selectedClientUserShortIdAtom,
} from "../state";
import { useAtomValue } from "jotai";
import { useHandleReflectionTopicCompletionCallback } from "./reflections/useHandleReflectionTopicCompletionCallback";

export function ClientActivityBetweenSessionCardWrapper() {
  const patientShortId =
    useAtomValue(selectedClientInfoAtom)?.patientShortId ?? "";
  const clientUserShortId = useAtomValue(selectedClientUserShortIdAtom) ?? "";
  const providerShortId = useAtomValue(providerShortIdAtom) ?? "";
  const isInSessionWithSelectedClient = useAtomValue(
    isInSessionWithSelectedClientAtom,
  );
  const inSessionPatientInfo = useAtomValue(inSessionPatientInformationAtom);
  const handleReflectionTopicCompletion =
    useHandleReflectionTopicCompletionCallback();

  // The appointment short ID should only be set for the
  // ClientActivityBetweenSessionsCardConnected component if the provider is
  // actively in session with the client whose activity they are viewing.
  const appointmentShortId = isInSessionWithSelectedClient
    ? inSessionPatientInfo?.inSessionAppointmentShortId
    : undefined;
  return (
    <ClientActivityBetweenSessionsCardConnected
      canCheckOffTopics
      patientShortId={patientShortId}
      clientUserShortId={clientUserShortId}
      providerShortId={providerShortId}
      appointmentShortId={appointmentShortId}
      onUpdateTopicCompletionStatusSuccess={handleReflectionTopicCompletion}
      providerViewEventType={
        ProviderEventType.VIEWED_CLIENT_ACTIVITY_BETWEEN_SESSIONS_NO_MEDICAL_RECORD_TELEHEALTH
      }
    />
  );
}
